export type UnavailabilityTypes = 'AT_CAPACITY' | 'ABN_CHANGE' | 'SHOP_CLOSURE';

export enum UnavailabilityTypeEnum {
  'AT_CAPACITY' = 'Paused (At Capacity)',
  'ABN_CHANGE' = 'ABN Transition',
  'SHOP_CLOSURE' = 'Shop Closure'
}

export const UNAVAILABILITY_TYPES = ['AT_CAPACITY', 'ABN_CHANGE', 'SHOP_CLOSURE'];
